import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {SharedService} from '../shared/shared-service';
import {AuthenticationService} from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(private router: Router, public sharedService: SharedService,
              private authenticaionService: AuthenticationService,
              private cookieService: CookieService) {
  }

  authTokenExistence() {
    let userData = this.sharedService.getUserDataFromSessionStorage();
    if (this.cookieService.get('securityToken') && userData) {
      return true;
    } else {
      this.cookieService.deleteAll();
      sessionStorage.clear();
      this.router.navigate(['/signin']);
      return false;
    }
  }

  // tslint:disable-next-line:max-line-length
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authTokenExistence();
  }

  // tslint:disable-next-line:max-line-length
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authTokenExistence();
  }

  resolve() {
    let userData = this.sharedService.getUserDataFromSessionStorage();
    if (this.cookieService.get('securityToken') && !userData) {
      this.authenticaionService.getLoggedInUserMetaData().subscribe(() => {
        userData = this.sharedService.getUserDataFromSessionStorage();
        this.router.navigate(['/permit-app']);
        return true
      });
    } else if (this.cookieService.get('securityToken') && userData) {
      return true;
    }
  }
}
